import { useState } from 'react'
import { SketchPicker } from 'react-color'
import { Popover, PopoverContent, PopoverTrigger } from '@shopflo/ui'
import { classNames, rgbHex } from 'src/lib/utils/helpers'

interface Props {
  label?: string
  themeColor: string | undefined
  setThemeColor?: any
  contrastColor?: string
  isDisabled?: boolean
  customizeUI?: {
    labelStyles: string
    disableDefaultLabel?: boolean
  }
}

const PopColorPicker: React.FC<Props> = ({
  label,
  themeColor,
  setThemeColor,
  contrastColor,
  isDisabled = false,
  customizeUI = {
    labelStyles: '',
    disableDefaultLabel: false
  }
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false)

  return (
    <div>
      <Popover open={displayColorPicker && !isDisabled} onOpenChange={setDisplayColorPicker}>
        <PopoverTrigger asChild disabled={isDisabled}>
          <div
            className={classNames(
              'flex items-center gap-1.5',
              isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
            )}
            onClick={() => !isDisabled && setDisplayColorPicker(!displayColorPicker)}
          >
            <div
              className={classNames(
                'relative inline-block w-[34px] h-[34px] rounded border border-gray-light',
                isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
              )}
              style={{
                backgroundColor: themeColor
              }}
            >
              {Boolean(contrastColor) && (
                <div
                  className={classNames(
                    'absolute right-1 bottom-1 w-3 h-3 rounded',
                    isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
                  )}
                  style={{
                    backgroundColor: contrastColor
                  }}
                />
              )}
            </div>
            <div className='flex flex-col justify-center gap-0'>
              <span className={classNames('text-sm font-semibold', customizeUI?.labelStyles)}>{label ?? ''}</span>
              {!customizeUI?.disableDefaultLabel && (
                <span className={classNames('text-xs font-normal leading-3', customizeUI?.labelStyles)}>
                  {themeColor?.toUpperCase()?.substring(0, 7)}
                </span>
              )}
              {customizeUI?.labelStyles && (
                <p className={customizeUI?.labelStyles}>{themeColor?.toUpperCase()?.substring(0, 7)}</p>
              )}
            </div>
          </div>
        </PopoverTrigger>

        <PopoverContent className='w-auto p-0 shadow-lg bg-white' align='start' sideOffset={8}>
          <SketchPicker
            disableAlpha={true}
            presetColors={[]}
            color={`${themeColor}`}
            onChange={(color: any) => {
              setThemeColor(
                '#' +
                  rgbHex(Number(color.rgb.r), Number(color.rgb.g), Number(color.rgb.b), Number(color.rgb.a))
                    ?.toUpperCase()
                    ?.substring(0, 6)
              )
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default PopColorPicker
